import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { SearchComponent } from './components/search/search.component';
import { VideoPlayerComponent } from './components/video-player/video-player.component';
import { ToastComponent } from './components/toast/toast.component';
import { BuildInfoService, BuildInfo } from './services/build-info.service';
import { FavoritesService } from './services/favorites.service';
import { KeyboardToastService } from './services/keyboard-toast.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [SearchComponent, VideoPlayerComponent, ToastComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit, OnDestroy {
  protected title = 'DrawFiend Show';
  protected buildInfo: BuildInfo | null = null;
  protected formattedBuildDate = 'unknown';
  protected shortHash = 'unknown';

  private buildInfoService = inject(BuildInfoService);
  private favoritesService = inject(FavoritesService); // Initialize favorites service
  private keyboardToastService = inject(KeyboardToastService);

  ngOnInit() {
    // Give the service time to load build info
    setTimeout(() => {
      this.buildInfo = this.buildInfoService.getBuildInfo();
      this.formattedBuildDate = this.buildInfoService.getFormattedBuildDate();
      this.shortHash = this.buildInfoService.getShortHash();
    }, 100);

    // Start listening for keyboard shortcuts
    this.keyboardToastService.startListening();
  }

  ngOnDestroy() {
    // Stop listening for keyboard shortcuts
    this.keyboardToastService.stopListening();
  }
}
